import { getNotifications } from '../../services/notifications.service';
import { SET_AUTOMATED_PAYMENTS_STATE, SET_NOTIFICATIONS_DATA, SET_TOOLTIP_TOGGLE } from './notificationType';

export const fetchNotifications =
  (page = 1, append = 'default') =>
  async (dispatch, getState) => {
    const currentState = getState().notifications;
    const prevLastMessageId = currentState.lastMessageId;
    try {
      const response = await getNotifications({
        page,
      });

      if (response?.status) {
        const { notifications, currentPage, totalPages, lastMessageId, unseenCount } = response.data;
        dispatch({
          type: SET_NOTIFICATIONS_DATA,
          payload: {
            notifications,
            currentPage: append === 'viewMore' ? currentPage : currentState.currentPage,
            totalPages,
            newMessage: lastMessageId !== prevLastMessageId || false,
            append: append,
            lastMessageId,
            unseenCount,
          },
        });
      }
    } catch (error) {
      console.error('Error fetching notifications:', error);
      dispatch({ type: 'NOTIFICATIONS_FETCH_ERROR', payload: error.message });
    }
  };

export const toggleShowNotificationTooltip = (show) => async (dispatch) => {
  dispatch({
    type: SET_TOOLTIP_TOGGLE,
    payload: show,
  });
};

export const setAutomatedPaymentsState = (state) => async (dispatch) => {
  dispatch({
    type: SET_AUTOMATED_PAYMENTS_STATE,
    payload: state,
  });
};
